<template>
    <div class="table-toolbar-wrapper">
        <div class="board-view-tabs">
            <div class="tabs-container">
                <div class="left">
                    <div
                        class="tab"
                        :class="{ active: currentBoardView === 'table' }"
                        @click="changeBoardView('table')"
                    >
                        <i class="material-icons">grid_on</i>
                        {{ $t("tables.table") }}
                    </div>
                    <div
                        class="tab"
                        :class="{ active: currentBoardView === 'kanban' }"
                        @click="changeBoardView('kanban')"
                    >
                        <i class="material-icons">view_kanban</i>
                        {{ $t("tables.kanban") }}
                    </div>
                    <div
                        class="tab"
                        :class="{ active: currentBoardView === 'calendar' }"
                        @click="changeBoardView('calendar')"
                    >
                        <i class="material-icons">event</i>
                        {{ $t("tables.calendar") }}
                    </div>
                    <div
                        v-for="page in customPages"
                        :key="page._id"
                        class="tab"
                        :class="{ active: currentBoardView === page._id }"
                    >
                        <div class="tab-content" @click="changeBoardView(page._id)">
                            <i class="material-icons">dashboard</i>
                            {{ page.name }}
                        </div>
                        <a-dropdown v-if="currentBoardView === page._id">
                            <a-button class="page-actions-btn">
                                <i class="material-icons">more_vert</i>
                            </a-button>
                            <a-menu slot="overlay" class="page-actions-menu">
                                <PermissionController :permissions="['table.update']">
                                    <a-menu-item @click="duplicatePage(page)">
                                        <i class="material-icons">content_copy</i>
                                        Sayfayı Çoğalt
                                    </a-menu-item>
                                </PermissionController>
                                <PermissionController :permissions="['table.update']">
                                    <a-menu-item @click="showRenamePageModal(page)">
                                        <i class="material-icons">edit</i>
                                        Sayfayı Yeniden Adlandır
                                    </a-menu-item>
                                </PermissionController>
                                <PermissionController :permissions="['table.update']">
                                    <a-menu-item @click="confirmDeletePage(page)">
                                        <i class="material-icons" style="color: #ff4d4f">delete</i>
                                        Sayfayı Sil
                                    </a-menu-item>
                                </PermissionController>
                            </a-menu>
                        </a-dropdown>
                    </div>
                    <PermissionController :permissions="['table.update']">
                        <a-popover placement="bottom" trigger="click">
                            <div slot="content">
                                <div class="template-list">
                                    <div class="template-item" @click="onCreateNewTablePage('blank')">
                                        <i class="material-icons">insert_drive_file</i>
                                        Blank
                                    </div>
                                    <div class="template-item" @click="onCreateNewTablePage('chart')">
                                        <i class="material-icons">insert_chart</i>
                                        Chart
                                    </div>
                                    <div class="template-item" @click="onCreateNewTablePage('form')">
                                        <i class="material-icons">assignment</i>
                                        Form
                                    </div>
                                    <div class="template-item" @click="onCreateNewTablePage('gantt')">
                                        <i class="material-icons">view_timeline</i>
                                        Gantt
                                    </div>
                                </div>
                            </div>
                            <div class="tab add-view">
                                <i class="material-icons">add</i>
                            </div>
                        </a-popover>
                    </PermissionController>
                </div>
                <div class="right" v-if="moduleMode && selectedModule">
                    <div class="module-title-wrapper">
                        <i class="material-icons">{{ selectedModule.icon || "extension" }}</i>
                        <h3 class="title">{{ selectedModule.displayName }}</h3>
                    </div>
                </div>

                <!--                şu an için buton işlevsiz olduğu için uı dan kaldırıldı-->
                <!--                <div class="tab add-view">-->
                <!--                    <i class="material-icons">add</i>-->
                <!--                </div>-->
            </div>
        </div>

        <div class="table-toolbar">
            <div class="left-actions">
                <a-popover
                    placement="bottomLeft"
                    trigger="click"
                    overlayClassName="view-switcher-popover zero-padding"
                    v-model="viewSwitcherVisible"
                >
                    <template slot="content">
                        <ViewSwitcher
                            :table="table"
                            @show-view="onShowView"
                            @edit-view="onEditView"
                            @create-new-view="onCreateNewView"
                            @view-deleted="onViewDeleted"
                            @view-duplicated="onViewDuplicated"
                            @view-updated="onViewUpdated"
                            :selected-view-id="$_.get(currentView, '_id')"
                        />
                    </template>
                    <SupsisButton primary>
                        {{ currentView ? currentView.name : `${$t("tables.mainTable")} - (${table.name})` }}
                        <i class="material-icons">arrow_drop_down</i>
                    </SupsisButton>
                </a-popover>
                <!-- Filter butonuna a-popover ekliyoruz -->
                <a-popover
                    placement="bottomLeft"
                    trigger="click"
                    :visible="filterVisible"
                    overlayClassName="table-filter-popover"
                >
                    <template slot="content">
                        <TableFilter
                            :fields="fields"
                            :value="filters"
                            :records="records"
                            @input="onFilterChange"
                            @close="filterVisible = false"
                        />
                    </template>
                    <SupsisButton
                        :classNames="`${filters.length > 0 ? 'active-filters' : ''}`"
                        @click="filterVisible = !filterVisible"
                    >
                        <i class="material-icons">filter_alt</i>
                        {{ $t("tables.filter") }}
                        <span v-if="filters.length > 0" class="filter-count">
                            {{ filters.length }}
                        </span>
                        <i class="material-icons clear-filters" @click.stop="clearFilters" v-if="filters.length"
                            >close</i
                        >
                    </SupsisButton>
                </a-popover>
                <SupsisButton
                    :classNames="`${hiddenFields.length > 0 ? 'active-filters' : ''}`"
                    @click="$emit('show-hide-fields')"
                    v-if="!moduleMode"
                >
                    <i class="material-icons">visibility_off</i>
                    {{ $t("tables.hideFields") }}
                    <span v-if="hiddenFields.length > 0" class="filter-count">
                        {{ hiddenFields.length }}
                    </span>
                    <i
                        class="material-icons clear-filters"
                        @click.stop="$emit('clear-hidden-fields')"
                        v-if="hiddenFields.length > 0"
                        >close</i
                    >
                </SupsisButton>
                <!-- Burada group by'ı ekliyoruz -->
                <a-popover
                    placement="bottomRight"
                    trigger="click"
                    v-model="groupPopoverVisible"
                    overlayClassName="table-group-popover"
                >
                    <template slot="content">
                        <TableGroup :fields="fields" :group-value="groupValue" @update-group="onUpdateGroup" />
                    </template>
                    <SupsisButton :classNames="`${groupValue.fieldId ? 'active-filters' : ''}`">
                        <i class="material-icons">category</i>
                        {{ $t("message.group") }}
                        <span v-if="groupValue.fieldId" class="filter-count"> 1 </span>
                    </SupsisButton>
                </a-popover>

                <a-popover
                    placement="bottomRight"
                    v-model="colorPopoverVisible"
                    trigger="click"
                    overlayClassName="table-color-popover"
                >
                    <template slot="content">
                        <TableColorFilter
                            :fields="fields"
                            :color-conditions="colorConditions"
                            @update-color-conditions="onUpdateColorConditions"
                        />
                    </template>
                    <SupsisButton :classNames="`${colorConditions.length > 0 ? 'active-filters' : ''}`">
                        <i class="material-icons">color_lens</i>
                        {{ $t("tables.conditionalColor") }}
                        <span v-if="colorConditions.length > 0" class="filter-count">
                            {{ colorConditions.length }}
                        </span>
                    </SupsisButton>
                </a-popover>
                <PermissionController :permissions="['table.update']">
                    <SupsisButton
                        @click="$feature.beforeCreateTableView(openCreateViewModal, table.totalViews)"
                        v-if="!moduleMode"
                    >
                        <i class="material-icons">save</i>
                        {{ $t("tables.saveAsView") }}
                    </SupsisButton>
                </PermissionController>
            </div>
            <div class="right-actions">
                <!-- Pagination bileşenini ekle -->
                <div
                    class="search-bar"
                    :class="{ expanded: searchExpanded || searchQuery }"
                    @click="searchExpanded = true"
                >
                    <input
                        type="text"
                        :placeholder="$t('tables.search')"
                        @keyup.enter="onSearchEnter"
                        @focus="searchExpanded = true"
                        @blur="searchExpanded = false"
                        ref="searchInput"
                        autofocus
                    />
                    <i class="material-icons" @click.stop="searchExpanded = true">search</i>
                </div>
                <PermissionController :permissions="['table.update']">
                    <a-tooltip v-if="isRecordLimitExceeded" placement="bottom">
                        <template slot="title">
                            Kayıt limiti doldu. Yeni kayıt eklemek için plan yükseltmeniz gerekiyor.
                        </template>
                        <a-badge :count="isRecordLimitExceeded ? '!' : 0" :number-style="{ backgroundColor: '#ff4d4f' }">
                            <SupsisButton
                                v-if="canCreateRecord"
                                primary
                                @click="$feature.beforeCreateTableRecord(openCreateRecordModal, total)"
                            >
                                <i class="material-icons">add</i>
                                {{ $t("message.createRecord") }}
                            </SupsisButton>
                        </a-badge>
                    </a-tooltip>
                    <SupsisButton
                        v-if="!isRecordLimitExceeded && canCreateRecord"
                        primary
                        @click="$feature.beforeCreateTableRecord(openCreateRecordModal, total)"
                    >
                        <i class="material-icons">add</i>
                        {{ $t("message.createRecord") }}
                    </SupsisButton>
                </PermissionController>
                <a-popover trigger="click" placement="bottomRight" v-if="!moduleMode">
                    <template slot="content">
                        <div class="action-menu">
                            <PermissionController :permissions="['automation.get']">
                                <div class="action-item" @click="handleAction('runWebhookAutomation')">
                                    <i class="material-icons" style="color: #1890ff">webhook</i>
                                    {{ $t("tables.runWebhookAutomation") }}
                                </div>
                            </PermissionController>
                            <PermissionController :permissions="['table.update']">
                                <a-tooltip v-if="canImportRecords && isRecordLimitExceeded" placement="left">
                                    <template slot="title">
                                        {{ $t("tables.recordLimitExceededTooltip") }}
                                    </template>
                                    <div
                                        class="action-item"
                                        @click="handleAction('importRecords')"
                                    >
                                        <i class="material-icons" style="color: #52c41a">upload_file</i>
                                        {{ $t("tables.importRecords") }}
                                        <a-badge dot :number-style="{ backgroundColor: '#ff4d4f' }" style="margin-left: 8px" />
                                    </div>
                                </a-tooltip>
                                <div
                                    v-if="canImportRecords && !isRecordLimitExceeded"
                                    class="action-item"
                                    @click="handleAction('importRecords')"
                                >
                                    <i class="material-icons" style="color: #52c41a">upload_file</i>
                                    {{ $t("tables.importRecords") }}
                                </div>
                            </PermissionController>
                            <div v-if="canExportRecords" class="action-item">
                                <a-popover trigger="click" placement="left">
                                    <template slot="content">
                                        <div class="action-menu">
                                            <div
                                                class="action-item"
                                                :class="{ disabled: !hasSelection }"
                                                @click.stop="hasSelection && downloadSelectedRecords()"
                                            >
                                                <i class="material-icons" style="color: #52c41a">check_box</i>
                                                {{
                                                    hasSelection
                                                        ? $t("tables.downloadSelectedWithCount", { count: selectedRecords.length })
                                                        : $t("tables.downloadSelected")
                                                }}
                                            </div>
                                            <div class="action-item" @click.stop="openExport('page')">
                                                <i class="material-icons" style="color: #faad14">file_download</i>
                                                {{ $t("tables.downloadThisPage") }}
                                            </div>
                                            <div class="action-item" @click.stop="openExport('all')">
                                                <i class="material-icons" style="color: #faad14">cloud_download</i>
                                                {{ $t("tables.downloadAll") }}
                                            </div>
                                        </div>
                                    </template>
                                    <span>
                                        <i class="material-icons" style="color: #faad14">download</i>
                                        {{ $t("tables.downloadRecords") }}
                                    </span>
                                </a-popover>
                            </div>
                            <PermissionController :permissions="['automation.get']">
                                <div
                                    v-if="canUpdateRecord"
                                    class="action-item"
                                    :class="{ disabled: !hasSelection }"
                                    @click="handleAction('editRecords')"
                                >
                                    <i class="material-icons" style="color: #1890ff">edit</i>
                                    {{
                                        hasSelection
                                            ? `${$t("message.edit")} ${selectedRecords.length} ${$t("message.records")}`
                                            : $t("tables.editRecords")
                                    }}
                                    <span class="shortcut"> <kbd>Ctrl</kbd>+<kbd>E</kbd> </span>
                                </div>
                            </PermissionController>
                            <PermissionController :permissions="['table.delete']">
                                <div
                                    v-if="canDeleteRecord"
                                    class="action-item"
                                    :class="{ disabled: !hasSelection }"
                                    @click="confirmDeleteRecords"
                                >
                                    <i class="material-icons" style="color: #ff4d4f">delete</i>
                                    {{
                                        hasSelection
                                            ? `${$t("message.delete")} ${selectedRecords.length} ${$t(
                                                  "message.records"
                                              )}`
                                            : $t("tables.deleteRecords")
                                    }}
                                    <span class="shortcut">
                                        <kbd>Backspace</kbd>
                                    </span>
                                </div>
                            </PermissionController>
                            <PermissionController :permissions="['table.update']">
                                <div
                                    v-if="canCreateRecord"
                                    class="action-item"
                                    :class="{ disabled: !hasSelection }"
                                    @click="confirmDuplicateRecords"
                                >
                                    <i class="material-icons" style="color: #52c41a">content_copy</i>
                                    {{
                                        hasSelection
                                            ? `${$t("message.duplicate")} ${selectedRecords.length} ${$t(
                                                  "message.records"
                                              )}`
                                            : $t("tables.duplicateRecords")
                                    }}
                                    <span class="shortcut"> <kbd>Ctrl</kbd>+<kbd>D</kbd> </span>
                                </div>
                            </PermissionController>
                            <div class="action-item" @click="handleAction('toggleZebraStripes')">
                                <i class="material-icons" style="color: #9254de">view_agenda</i>
                                {{ $t("tables.zebraMode") }}
                                <a-switch size="small" :checked="zebraStripes" class="zebra-switch" />
                            </div>
                            <div v-if="canShowPermissionSettings" class="action-item" @click="handleAction('privacySettings')">
                                <i class="material-icons" style="color: #722ed1">admin_panel_settings</i>
                                {{ $t("tables.privacySettings") }}
                            </div>
                        </div>
                    </template>
                    <SupsisButton>
                        <i class="material-icons">more_horiz</i>
                    </SupsisButton>
                </a-popover>
                <!-- CreateViewForm'u içeren Modal2 bileşeni -->
                <Modal2
                    v-if="showCreateViewModal"
                    @cancel="closeCreateViewModal"
                    :showFooter="false"
                    :title="$t('tables.saveAsView')"
                    className="create-view-modal keydown-prevent-modal"
                >
                    <CreateViewForm
                        :filters="filters"
                        :sort="sort"
                        :search="searchQuery"
                        :hiddenFields="hiddenFields"
                        :lockedFields="lockedFields"
                        @view-created="onViewCreated"
                        @cancel="closeCreateViewModal"
                        :table-id="tableId"
                        :group-value="groupValue"
                        :color-conditions="colorConditions"
                    />
                </Modal2>
            </div>

            <Modal2
                v-if="showCreateRecordModal"
                @cancel="closeCreateRecordModal"
                :showFooter="false"
                title="Yeni Kayıt Oluştur"
                className="create-record-modal keydown-prevent-modal"
            >
                <TableCreateRecordForm
                    :table="table"
                    @record-created="onRecordCreated"
                    :predefinedValues="predefinedValues"
                    :default-linked-record-cache="defaultLinkedRecordCache"
                />
            </Modal2>
        </div>

        <!-- Yeni sayfa oluşturma modalı -->
        <Modal2
            v-if="showCreatePageModal"
            title="Yeni Sayfa Oluştur"
            @cancel="closeCreatePageModal"
            @ok="handleCreatePage"
            :okText="'Oluştur'"
            :cancelText="'İptal'"
            :showFooter="true"
        >
            <a-form :form="createPageForm" layout="vertical">
                <a-form-item label="Sayfa Adı">
                    <a-input
                        v-decorator="[
                            'name',
                            {
                                rules: [{ required: true, message: 'Lütfen sayfa adı girin' }],
                            },
                        ]"
                        placeholder="Sayfa adı girin"
                    />
                </a-form-item>
                <a-form-item label="Açıklama">
                    <a-textarea v-decorator="['description']" :rows="4" placeholder="Sayfa açıklaması girin" />
                </a-form-item>
            </a-form>
        </Modal2>

        <!-- Rename Page Modal -->
        <Modal2
            v-if="showRenameModal"
            title="Sayfayı Yeniden Adlandır"
            @cancel="closeRenameModal"
            @ok="handleRename"
            :confirmLoading="renamingPage"
            :okText="'Kaydet'"
            :cancelText="'İptal'"
        >
            <a-form-item label="Sayfa Adı">
                <a-input v-model="newPageName" placeholder="Sayfa adı girin" />
            </a-form-item>
        </Modal2>

        <!-- Export Settings Modal -->
        <Modal2
            v-if="showExportSettings"
            :title="$t('tables.downloadRecordsSettings')"
            @cancel="closeExportSettings"
            className="export-settings-modal keydown-prevent-modal"
            :showFooter="false"
            xlarge
        >
            <ExportSettings
                :fields="fields"
                :records="records"
                @start="onExportSettingsStart"
                @cancel="closeExportSettings"
            />
        </Modal2>

        <!-- Export Progress Overlay -->
        <div v-if="exportInProgress" class="export-progress-overlay">
            <div class="export-progress-card">
                <div class="title">Excel Dışa Aktarım</div>
                <div class="subtitle">Toplam {{ exportProgress.total }} kayıt</div>
                <a-progress :percent="exportProgress.percent" status="active" />
                <div class="detail">
                    <span>{{ exportProgress.fetched }} / {{ exportProgress.total }}</span>
                    <a-button size="small" style="margin-left: 8px" @click="cancelExport" v-if="exportInProgress">İptal</a-button>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import Vue from "vue";
import TableGroup from "./components/TableGroup.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import TableFilter from "./components/filter/TableFilter.vue";
import { Popover } from "ant-design-vue";
import { TABLE_API } from "../../../../api/table";
import Modal2 from "../../../../components/common/Modal2.vue";
import CreateViewForm from "./components/CreateViewForm.vue";
import ViewSwitcher from "./components/ViewSwitcher.vue";
import TableCreateRecordForm from "./RecordCreator.vue";
import TableColorFilter from "./components/filter/TableColorFilter.vue";
import ExportSettings from "./components/ExportSettings.vue";
import moment from "moment";
import { expertToExcel } from "../../../../utils/utils";
import { checkTablePermission, getUserDepartments, canEditTablePermissions } from "../../../../utils/TablePermissionUtils";
import { TABLE_PERMISSION_SCOPES } from "../../../../utils/TablePermissionScopes";
import { mapState } from "vuex";

export default Vue.extend({
    name: "TableToolbar",
    components: {
        ViewSwitcher,
        SupsisButton,
        TableFilter,
        "a-popover": Popover,
        Modal2,
        CreateViewForm,
        TableCreateRecordForm,
        TableGroup,
        TableColorFilter,
        ExportSettings,
    },
    props: {
        fields: {
            type: Array,
            required: true,
        },
        filters: {
            type: Array,
            default: function () {
                return [];
            },
        },
        selectedRecords: {
            type: Array,
            default: function () {
                return [];
            },
        },
        tableId: {
            type: String,
            required: true,
        },
        hiddenFields: {
            type: Array,
            default: function () {
                return [];
            },
        },
        lockedFields: {
            type: Array,
            default: function () {
                return [];
            },
        },
        sort: {
            type: Object,
            default: function () {
                return {};
            },
        },
        table: {
            type: Object,
            required: true,
        },
        currentView: {
            type: Object,
            default: null,
        },
        total: {
            type: Number,
            default: 0,
        },
        cursor: {
            type: Object,
            default: function () {
                return {
                    page: 1,
                    perPage: 1000,
                };
            },
        },
        moduleMode: {
            type: Boolean,
            default: false,
        },
        predefinedValues: {
            type: Object,
            default: function () {
                return {};
            },
        },
        defaultLinkedRecordCache: {
            type: Object,
        },
        groupValue: {
            type: Object,
            default: function () {
                return {
                    fieldId: null,
                    direction: "asc",
                    showEmptyGroups: false,
                };
            },
        },
        currentBoardView: {
            type: String,
            default: "table",
        },
        colorConditions: {
            type: Array,
            default: function () {
                return [];
            },
        },
        searchQuery: {
            type: String,
        },
        selectedModule: {
            type: Object,
            default: null,
        },
        customPages: {
            type: Array,
            default: () => [],
        },
        zebraStripes: {
            type: Boolean,
            default: true,
        },
        records: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
        }),
        userDepartments() {
            return getUserDepartments(this.user);
        },
        hasSelection() {
            return this.selectedRecords.length > 0;
        },
        canCreateRecord() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_CREATE);
        },
        canUpdateRecord() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_UPDATE);
        },
        canDeleteRecord() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_DELETE);
        },
        canImportRecords() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.BULK_IMPORT);
        },
        canExportRecords() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT);
        },
        isRootUser() {
            return this.adminUser || (this.user && this.user.role && this.user.role.isRoot);
        },
        canShowPermissionSettings() {
            return canEditTablePermissions(this.table, this.user, this.adminUser);
        },
        isRecordLimitExceeded() {
            return this.$feature.isTableRecordLimitExceeded(this.total);
        },
    },
    data() {
        return {
            filterVisible: false,
            showCreateViewModal: false,
            viewSwitcherVisible: false,
            showCreateRecordModal: false,
            groupPopoverVisible: false,
            colorPopoverVisible: false,
            searchExpanded: false,
            customViews: [],
            showCreatePageModal: false,
            createPageForm: this.$form.createForm(this),
            isCreatingPage: false,
            selectedTemplateType: null,
            showRenameModal: false,
            newPageName: "",
            renamingPage: false,
            selectedPage: null,

            // Export state
            showExportSettings: false,
            exportMode: "page", // 'page' | 'all'
            exportInProgress: false,
            exportProgress: {
                fetched: 0,
                total: 0,
                percent: 0,
            },
            exportCancel: null,
            lastExportSettings: null,
        };
    },
    methods: {
        checkPermission(scope) {
            return checkTablePermission(this.table, scope, this.user, this.adminUser, this.userDepartments);
        },
        onFilterChange(filters) {
            this.$emit("filter-updated", filters);
        },
        clearFilters() {
            this.$emit("filter-updated", []);
        },
        onSearchEnter(event) {
            this.$emit("search", event.target.value);
        },
        handleAction(action) {
            switch (action) {
                case "editRecords":
                    if (this.hasSelection) {
                        this.$emit("edit-records");
                    }
                    break;
                case "importRecords":
                    this.importRecords();
                    break;
                case "downloadSelectedRecords":
                    if (this.hasSelection) {
                        if (!this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT)) {
                            this.$message.error(this.$t("tables.permissions.noPermission"));
                            return;
                        }
                        this.$emit("download-selected-records");
                    }
                    break;
                case "downloadAllRecords":
                    if (!this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT)) {
                        this.$message.error(this.$t("tables.permissions.noPermission"));
                        return;
                    }
                    this.$emit("download-all-records");
                    break;
                case "editRecords":
                    if (this.hasSelection) {
                        this.$emit("edit-records");
                    }
                    break;
                case "toggleZebraStripes":
                    this.toggleZebraStripes();
                    break;
                case "privacySettings":
                    this.goToPrivacySettings();
                    break;
                // Diğer aksiyonlar...
            }
        },
        confirmDeleteRecords() {
            if (!this.hasSelection) return;
            this.$confirm({
                title: this.$t("tables.deleteRecords"),
                content:
                    this.$t("tables.selected") +
                    " " +
                    this.selectedRecords.length +
                    " " +
                    this.$t("tables.sureDeleteRecords"),
                okText: this.$t("message.yes"),
                okType: "danger",
                cancelText: this.$t("message.no"),
                onOk: () => {
                    this.deleteSelectedRecords();
                },
            });
        },
        async deleteSelectedRecords() {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_DELETE)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }

            try {
                await TABLE_API.deleteRecordsByIds(this.tableId, this.selectedRecords);
                this.$emit("records-deleted", this.selectedRecords);
                this.$message.success(this.$t("tables.selectedRecordSucs"));
            } catch (error) {
                console.error("Kayıtlar silinirken bir hata oluştu:", error);
                this.$message.error(this.$t("tables.errorDeletingRecords"));
            }
        },
        confirmDuplicateRecords() {
            if (!this.hasSelection) return;
            this.$confirm({
                title: this.$t("tables.copyRecords"),
                content:
                    this.$t("tables.selected") +
                    " " +
                    this.selectedRecords.length +
                    " " +
                    this.$t("tables.sureCopyRecords"),
                okText: this.$t("message.yes"),
                okType: "primary",
                cancelText: this.$t("message.no"),
                onOk: () => {
                    this.duplicateSelectedRecords();
                },
            });
        },
        async duplicateSelectedRecords() {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_CREATE)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }

            try {
                await TABLE_API.duplicateRecords(this.tableId, this.selectedRecords);
                this.$emit("records-duplicated", this.selectedRecords);
                this.$message.success(this.$t("tables.recordsCopiedSucs"));
            } catch (error) {
                console.error("Kayıtlar kopyalanırken bir hata oluştu:", error);
                this.$message.error(this.$t("tables.recordsCopiedError"));
            }
        },
        handleKeyDown(event) {
            if (!this.hasSelection) return;

            if ((event.ctrlKey || event.metaKey) && event.key === "Backspace") {
                event.preventDefault();
                this.confirmDeleteRecords();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "d") {
                event.preventDefault();
                this.confirmDuplicateRecords();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "e") {
                event.preventDefault();
                this.handleAction("editRecords");
            }
        },
        openCreateViewModal() {
            this.showCreateViewModal = true;
        },
        closeCreateViewModal() {
            this.showCreateViewModal = false;
        },
        onViewCreated(newView) {
            this.$emit("view-created", newView);
            this.closeCreateViewModal();
            this.$message.success(this.$t("tables.viewSucsCreated"));
        },
        onShowView(view) {
            this.viewSwitcherVisible = false;
            this.$emit("show-view", view);
        },
        onEditView(view) {
            this.viewSwitcherVisible = false;
            this.$emit("edit-view", view);
        },
        onCreateNewView() {
            this.viewSwitcherVisible = false;
            this.$feature.beforeCreateTableView(() => {
                this.showCreateViewModal = true;
            }, this.table.totalViews);
            this.$emit("create-new-view", template);
        },
        onCreateNewTablePage(templateType) {
            this.selectedTemplateType = templateType;
            this.showCreatePageModal = true;
        },
        closeCreatePageModal() {
            this.showCreatePageModal = false;
            this.createPageForm.resetFields();
            this.selectedTemplateType = null;
        },
        async handleCreatePage() {
            try {
                const values = await new Promise((resolve, reject) => {
                    this.createPageForm.validateFields((err, values) => {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(values);
                        }
                    });
                });

                this.isCreatingPage = true;

                const newPage = await TABLE_API.createTablePage(
                    this.table._id,
                    values.name,
                    values.description,
                    this.selectedTemplateType
                );

                this.$message.success("Sayfa başarıyla oluşturuldu");
                this.closeCreatePageModal();

                // Parent component'e yeni sayfanın oluşturulduğunu bildir
                this.$emit("page-created", newPage);

                // Yeni oluşturulan sayfaya geç
                this.changeBoardView(newPage._id);
            } catch (error) {
                if (error.isFieldsError) {
                    return;
                }
                console.error("Sayfa oluşturulurken hata:", error);
                this.$message.error("Sayfa oluşturulurken bir hata oluştu");
            } finally {
                this.isCreatingPage = false;
            }
        },
        importRecords() {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.BULK_IMPORT)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.$emit("open-import-modal");
        },
        openCreateRecordModal() {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_CREATE)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.showCreateRecordModal = true;
        },
        closeCreateRecordModal() {
            this.showCreateRecordModal = false;
        },
        onRecordCreated(newRecord) {
            this.$emit("record-created", newRecord);
            this.closeCreateRecordModal();
        },
        onPageChange(page) {
            this.$emit("change-cursor", Object.assign({}, this.cursor, { page: page }));
        },
        onUpdateGroup(newGroup) {
            this.groupPopoverVisible = false;
            this.$emit("group-changed", newGroup);
        },
        changeBoardView(view) {
            if (view === "table" || view === "kanban" || view === "calendar") {
                // Temel görünümlerde pageId'yi URL'den kaldır
                const query = { ...this.$route.query };
                delete query.pageId;
                this.$router.replace({ query });
            } else {
                // Özel sayfa görünümlerinde pageId'yi URL'ye ekle
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        pageId: view,
                    },
                });
            }
            this.$emit("board-view-changed", view);
        },
        onUpdateColorConditions(newColorConditions) {
            console.log("[conditioning color] onUpdateColorConditions TableToolbar", newColorConditions);
            this.$emit("update-color-conditions", newColorConditions);
        },
        async duplicatePage(page) {
            try {
                const duplicatedPage = await TABLE_API.duplicatePage(this.table._id, page._id);
                this.$emit("page-created", duplicatedPage);
                this.$message.success("Sayfa başarıyla çoğaltıldı");
                this.changeBoardView(duplicatedPage._id);
            } catch (error) {
                console.error("Sayfa çoğaltılırken hata oluştu:", error);
                this.$message.error("Sayfa çoğaltılırken bir hata oluştu");
            }
        },
        showRenamePageModal(page) {
            this.selectedPage = page;
            this.newPageName = page.name;
            this.showRenameModal = true;
        },
        async handleRename() {
            if (!this.newPageName.trim()) {
                this.$message.warning("Lütfen sayfa adı girin");
                return;
            }

            try {
                this.renamingPage = true;
                await TABLE_API.updateTablePage(this.table._id, this.selectedPage._id, {
                    name: this.newPageName,
                });

                // Emit event to update the page in parent component
                this.$emit("page-updated", {
                    ...this.selectedPage,
                    name: this.newPageName,
                });

                this.$message.success("Sayfa adı başarıyla güncellendi");
                this.closeRenameModal();
            } catch (error) {
                console.error("Sayfa adı güncellenirken hata oluştu:", error);
                this.$message.error("Sayfa adı güncellenirken bir hata oluştu");
            } finally {
                this.renamingPage = false;
            }
        },
        closeRenameModal() {
            this.showRenameModal = false;
        },
        confirmDeletePage(page) {
            const tableId = this.table._id;
            const self = this;
            this.$confirm({
                title: "Sayfayı Sil",
                content: "Bu sayfayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                okText: "Evet",
                okType: "danger",
                cancelText: "Hayır",
                async onOk() {
                    try {
                        await TABLE_API.deleteTablePage(tableId, page._id);
                        self.$emit("page-deleted", page._id);
                        self.$message.success("Sayfa başarıyla silindi");
                        self.changeBoardView("table");
                    } catch (error) {
                        console.error("Sayfa silinirken hata oluştu:", error);
                        self.$message.error("Sayfa silinirken bir hata oluştu");
                    }
                },
            });
        },
        onViewDeleted(viewId) {
            this.$emit("view-deleted", viewId);
        },
        onViewDuplicated(newView) {
            this.$emit("view-duplicated", newView);
        },
        onViewUpdated(updatedView) {
            this.$emit("view-updated", updatedView);
        },
        toggleZebraStripes() {
            this.$emit("toggle-zebra-stripes");
        },
        goToPrivacySettings() {
            this.$router.push(`/tables/t/${this.table._id}/permissions`);
        },
        downloadSelectedRecords() {
            if (!this.hasSelection) return;
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.$emit("download-selected-records");
        },
        // Export submenu actions
        openExport(mode) {
            this.exportMode = mode === "all" ? "all" : "page";
            this.showExportSettings = true;
        },
        closeExportSettings() {
            this.showExportSettings = false;
        },
        async onExportSettingsStart(settings) {
            this.lastExportSettings = settings;
            this.showExportSettings = false;

            // Kısa bir gecikme ile modal'ın kapanmasını garanti et
            await this.$nextTick();

            if (this.exportMode === "page") {
                await this.startPageExport(settings);
            } else {
                await this.startFullExport(settings);
            }
        },
        async startPageExport(settings) {
            try {
                const excelData = this.buildExcelData(this.records, settings);
                expertToExcel(excelData, `records.xlsx`, "records");
                this.$message.success(this.$t("Excel dosyası başarıyla oluşturuldu"));

                // Activity log
                try {
                    console.log('TableToolbar - startPageExport - Activity log başlatılıyor', {
                        activityType: 'TABLE_DATA_DOWNLOADED',
                        tableId: this.tableId,
                        tableName: this.table ? this.table.name : '',
                        recordCount: excelData.length
                    });

                    const result = await this.$store.dispatch('activity/logDownloadActivity', {
                        activityType: 'TABLE_DATA_DOWNLOADED',
                        data: {
                            tableId: this.tableId,
                            tableName: this.table ? this.table.name : '',
                            recordCount: excelData.length,
                            format: 'excel',
                            onlySelected: false,
                            mode: 'page'
                        }
                    });

                    console.log('TableToolbar - startPageExport - Activity log sonucu:', result);

                    if (!result || !result.success) {
                        console.error('TableToolbar - startPageExport - Activity log başarısız:', result);
                    }
                } catch (error) {
                    console.error('TableToolbar - startPageExport - Activity log error:', error);
                }
            } catch (e) {
                console.error("Page export error", e);
                this.$message.error(this.$t("Excel dosyası oluşturulurken bir hata oluştu"));
            }
        },
        async startFullExport(settings) {
            try {
                const perPage = 200;
                const total = this.total || 0;
                if (!total) {
                    this.$message.info(this.$t("İndirilecek kayıt bulunamadı"));
                    return;
                }

                // İlerleme göstergesini başlat
                this.exportInProgress = true;
                this.exportProgress = { fetched: 0, total: total, percent: 0 };
                this.exportCancel = { cancelled: false };

                // DOM güncellemesini bekle
                await this.$nextTick();

                const all = [];
                const pageCount = Math.ceil(total / perPage);
                for (let page = 1; page <= pageCount; page++) {
                    if (this.exportCancel && this.exportCancel.cancelled) break;
                    const cursor = { page: page, perPage: perPage };
                    // Sıralama gönderilmeyecek
                    const result = await TABLE_API.listRecordsV2(
                        this.tableId,
                        this.filters,
                        {},
                        cursor,
                        this.searchQuery
                    );
                    const items = (result && result.items) || [];
                    for (let i = 0; i < items.length; i++) all.push(items[i]);

                    // Progress güncelleme
                    const fetched = Math.min(page * perPage, total);
                    const percent = Math.floor((fetched / total) * 100);
                    this.exportProgress = { fetched: fetched, total: total, percent: percent };

                    // UI güncellemesi için kısa bekle
                    await this.$nextTick();
                }

                if (!this.exportCancel || !this.exportCancel.cancelled) {
                    const excelData = this.buildExcelData(all, settings);
                    expertToExcel(excelData, `records.xlsx`, "records");
                    this.$message.success(this.$t("Excel dosyası başarıyla oluşturuldu"));

                    // Activity log
                    try {
                        console.log('TableToolbar - startFullExport - Activity log başlatılıyor', {
                            activityType: 'TABLE_DATA_DOWNLOADED',
                            tableId: this.tableId,
                            tableName: this.table ? this.table.name : '',
                            recordCount: excelData.length,
                            total: total
                        });

                        const result = await this.$store.dispatch('activity/logDownloadActivity', {
                            activityType: 'TABLE_DATA_DOWNLOADED',
                            data: {
                                tableId: this.tableId,
                                tableName: this.table ? this.table.name : '',
                                recordCount: excelData.length,
                                format: 'excel',
                                onlySelected: false,
                                mode: 'all',
                                totalRecords: total
                            }
                        });

                        console.log('TableToolbar - startFullExport - Activity log sonucu:', result);

                        if (!result || !result.success) {
                            console.error('TableToolbar - startFullExport - Activity log başarısız:', result);
                        }
                    } catch (error) {
                        console.error('TableToolbar - startFullExport - Activity log error:', error);
                    }
                } else {
                    this.$message.info(this.$t("Dışa aktarma iptal edildi"));
                }
            } catch (e) {
                console.error("Full export error", e);
                this.$message.error(this.$t("Excel dosyası oluşturulurken bir hata oluştu"));
            } finally {
                this.exportInProgress = false;
                this.exportCancel = null;
            }
        },
        cancelExport() {
            if (this.exportCancel) this.exportCancel.cancelled = true;
        },
        buildExcelData(records, settings) {
            const cols = (settings && settings.columns) || [];
            const rows = [];
            for (let r = 0; r < records.length; r++) {
                const record = records[r];
                const row = {};
                for (let s = 0; s < cols.length; s++) {
                    const col = cols[s];
                    const field = this.fields.find(function (f) { return f._id === col.fieldId; });
                    if (!field) continue;
                    this.appendColumn(row, field, record, col);
                }
                rows.push(row);
            }
            return rows;
        },
        appendColumn(row, field, record, col) {
            try {
                const value = record && record.data ? record.data[field._id] : undefined;
                const colBase = col.label || field.name;

                // Exclusions
                if (field.fieldType === "automation-button" || field.fieldType === "json" || field.fieldType === "event") {
                    return;
                }

                // valueType simple
                if (field.valueType === "string" || field.valueType === "number") {
                    let strVal = value == null ? "" : String(value);
                    if (field.valueType === "string" && strVal && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(strVal)) {
                        strVal = moment(strVal).format(col.dateFormat || "DD.MM.YYYY HH:mm");
                    }
                    row[colBase] = strVal;
                    return;
                }
                if (field.valueType === "boolean") {
                    const fmt = col.booleanFormat || "true-false";
                    var trueVal = "true";
                    var falseVal = "false";
                    if (fmt === "evet-hayır") {
                        trueVal = "Evet"; falseVal = "Hayır";
                    } else if (fmt === "var-yok") {
                        trueVal = "Var"; falseVal = "Yok";
                    } else if (fmt === "1-0") {
                        trueVal = "1"; falseVal = "0";
                    }
                    row[colBase] = value ? trueVal : falseVal;
                    return;
                }
                if (field.valueType === "date") {
                    const format = col.dateFormat || "DD.MM.YYYY HH:mm";
                    row[colBase] = value ? moment(value).format(format) : "";
                    return;
                }
                if (field.valueType === "array") {
                    if (!value) { row[colBase] = ""; return; }
                    const arr = Array.isArray(value) ? value : [value];
                    row[colBase] = arr.filter(function (x) { return x != null; }).join(", ");
                    return;
                }
                if (field.valueType === "asset") {
                    if (!value) return;
                    const prop = col.assetProp || "cdnUrl";
                    const key = colBase;
                    row[key] = value && value[prop] != null ? value[prop] : "";
                    return;
                }

                // objectId based types
                if (field.valueType === "objectId") {
                    const ft = field.fieldType;
                    if (ft === "user") {
                        const userProp = col.userProp || "name";
                        if (value && typeof value === "object") row[colBase] = value[userProp];
                        else row[colBase] = value;
                        return;
                    }
                    if (ft === "contact") {
                        const prop = col.contactProp || "fullname";
                        const key = colBase;
                        var v = value && typeof value === "object" ? value[prop] : value;
                        if (prop === "channel") {
                            try {
                                const channels = this.$store && this.$store.state && this.$store.state.channel ? this.$store.state.channel.channels : [];
                                const ch = channels && channels.find ? channels.find(function (c) { return c._id === v; }) : null;
                                v = ch ? ch.name : v;
                            } catch (e) {}
                        }
                        row[key] = v == null ? "" : v;
                        return;
                    }
                    if (ft === "ticket") {
                        const prop = col.ticketProp || "subject";
                        const key = colBase;
                        var v = value && typeof value === "object" ? value[prop] : value;
                        row[key] = v == null ? "" : v;
                        return;
                    }
                    if (ft === "task") {
                        const prop = col.taskProp || "title";
                        const key = colBase;
                        var v = value && typeof value === "object" ? value[prop] : value;
                        row[key] = v == null ? "" : v;
                        return;
                    }
                    if (ft === "conversation") {
                        const prop = col.conversationProp || "_id";
                        var v = value && typeof value === "object" ? value[prop] : value;
                        const key = colBase;
                        if (prop === "createdDate" && v) {
                            const format = col.dateFormat || "YYYY-MM-DD HH:mm";
                            v = moment(v).format(format);
                        }
                        row[key] = v == null ? "" : v;
                        return;
                    }
                    if (ft === "linked-record") {
                        const key = colBase;
                        var v = value && typeof value === "object" ? value._id : value;
                        row[key] = v == null ? "" : v;
                        return;
                    }

                    // default objectId stringify
                    row[colBase] = value && typeof value === "object" ? (value._id || JSON.stringify(value)) : value;
                    return;
                }

                // Fallback
                row[colBase] = value == null ? "" : String(value);
            } catch (e) {
                // keep row resilient
            }
        },
    },
    created() {},
    mounted() {
        document.addEventListener("keydown", this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handleKeyDown);
    },
});
</script>

<style scoped lang="scss">
.table-toolbar-wrapper {
    background-color: #f5f5f5;
}

.board-view-tabs {
    border-bottom: 1px solid #e8e8e8;

    .tabs-container {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 4px;
        }

        .right {
            .module-title-wrapper {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 10px;

                h3 {
                    margin: 0;
                }
            }
        }
    }

    .tab {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
        margin-bottom: -1px;

        .tab-content {
            display: flex;
            align-items: center;
            gap: 6px;
        }

        .page-actions-btn {
            padding: 0 4px;
            border: none;
            background: transparent;
            margin-left: 8px;
            height: fit-content !important;

            &:hover {
                background-color: rgba(0, 0, 0, 0.04);
            }

            .material-icons {
                font-size: 18px;
            }
        }

        &:hover {
            background-color: #e6e6e6;
        }

        &.active {
            background-color: white;
            border: 1px solid #e8e8e8;
            border-bottom-color: white;
        }

        &.add-view {
            padding: 8px;
            margin-left: 8px;

            .material-icons {
                font-size: 20px;
            }
        }

        i {
            font-size: 18px;
        }
    }
}

.table-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e8e8e8;
}

.left-actions {
    display: flex;
    gap: 10px;
}

.right-actions {
    display: flex;
    align-items: center;
    gap: 10px;

    :deep(.ant-pagination) {
        margin-left: 10px;
    }
}

.btn {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;

    &.btn-primary {
        background-color: #007bff;
        color: #fff;
    }

    &.btn-secondary {
        background-color: #fff;
        color: #333;
        border: 1px solid #ccc;
    }

    .material-icons {
        margin-right: 5px;
    }

    &.dropdown-toggle::after {
        content: "\e5c5";
        font-family: "Material Icons";
        vertical-align: middle;
        margin-left: 5px;
    }
}

.search-bar {
    position: relative;
    transition: width 0.3s ease;

    &.expanded {
        width: 200px;

        input {
            opacity: 1;
        }
    }

    input {
        padding: 8px 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 14px;
        width: 100%;
        opacity: 0;
        transition: opacity 0.3s ease;

        .expanded & {
            opacity: 1;
        }
    }

    .material-icons {
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        color: #999;
        cursor: pointer;
    }
}

.active-filters {
    background-color: #fe6244 !important;
    color: white;
}

.filter-count {
    margin-left: 4px;
    background-color: rgba(0, 0, 0, 0.2);
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 12px;
    display: inline-flex;
    align-items: center;

    .clear-filters {
        font-size: 14px;
        margin-left: 2px;
        cursor: pointer;
    }
}

.action-menu {
    display: flex;
    flex-direction: column;

    .action-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        &.disabled {
            cursor: not-allowed;
            color: #ccc;

            .material-icons {
                color: #ccc !important;
            }
        }

        .material-icons {
            margin-right: 8px;
        }

        .shortcut {
            margin-left: 8px;
            color: #999;
            font-size: 12px;

            kbd {
                display: inline-block;
                padding: 2px 4px;
                font-size: 11px;
                line-height: 1;
                color: #666;
                background-color: #f7f7f7;
                border: solid 1px #ccc;
                border-bottom-color: #bbb;
                border-radius: 3px;
                box-shadow: inset 0 -1px 0 #bbb;
            }
        }
    }
}

.table-color-popover {
    max-width: 300px;
}

.template-list {
    display: flex;
    flex-direction: column;

    .template-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
            background-color: #f5f5f5;
        }

        .material-icons {
            font-size: 20px;
        }
    }
}

:deep(.ant-dropdown-menu-item) {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;

    .material-icons {
        font-size: 18px;
    }
}
</style>
<style lang="scss">
.supsis-button {
    &.active-filters {
        background-color: #1890ff;
        color: white;
    }
}

.page-actions-menu {
    .ant-dropdown-menu-item {
        display: flex;
        align-items: center;
        gap: 8px;
    }
}

.zebra-switch {
    margin-left: auto;
}

.export-progress-overlay {
    position: fixed;
    right: 16px;
    bottom: 16px;
    z-index: 2000;
    pointer-events: none;

    .export-progress-card {
        pointer-events: all;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        padding: 12px 16px;
        min-width: 280px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);

        .title {
            font-weight: 600;
            margin-bottom: 4px;
        }
        .subtitle {
            color: #888;
            font-size: 12px;
            margin-bottom: 8px;
        }
        .detail {
            text-align: right;
            font-size: 12px;
            color: #555;
            margin-top: 6px;
        }
    }
}
</style>
